import { __ } from '~/locale';

export const SORT_LABEL_NAME = __('Name');
export const SORT_LABEL_CREATED = __('Created date');
export const SORT_LABEL_UPDATED = __('Updated date');
export const SORT_LABEL_STARS = __('Stars');

export const FILTERED_SEARCH_TOKEN_LANGUAGE = 'language';
export const FILTERED_SEARCH_TOKEN_MIN_ACCESS_LEVEL = 'min_access_level';
